(function () {
  var KEY = 'vivenda_favorites';

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; }
  }
  function persist(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
  }
  function write(list) {
    persist(list);
    update();
  }
  function has(id) {
    return read().some(function (i) { return String(i.id) === String(id); });
  }
  function count() { return read().length; }

  function escapeHtml(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function dataFromBtn(btn) {
    return {
      id: btn.getAttribute('data-fav-id'),
      handle: btn.getAttribute('data-fav-handle') || '',
      title: btn.getAttribute('data-fav-title') || '',
      vendor: btn.getAttribute('data-fav-vendor') || '',
      url: btn.getAttribute('data-fav-url') || '#',
      image: btn.getAttribute('data-fav-image') || '',
      price: btn.getAttribute('data-fav-price') || '',
      compare: btn.getAttribute('data-fav-compare') || ''
    };
  }

  function setBtnState(btn, on) {
    btn.setAttribute('data-on', on ? '1' : '0');
    btn.classList.toggle('is-fav', on);
    btn.setAttribute('aria-label', on ? 'Favorilerden çıkar' : 'Favorilere ekle');
    var svg = btn.querySelector('svg');
    if (svg) {
      svg.setAttribute('fill', on ? '#F27A1A' : 'none');
      svg.setAttribute('stroke', on ? '#F27A1A' : '#6F6F6F');
    }
  }

  function syncByIds(id, on) {
    var all = document.querySelectorAll('[data-fav-id]');
    for (var i = 0; i < all.length; i++) {
      if (String(all[i].getAttribute('data-fav-id')) === String(id)) setBtnState(all[i], on);
    }
  }

  function toggle(btn) {
    var d = dataFromBtn(btn);
    if (!d.id) return;
    var list = read();
    var idx = -1;
    for (var i = 0; i < list.length; i++) { if (String(list[i].id) === String(d.id)) { idx = i; break; } }
    var on;
    if (idx >= 0) { list.splice(idx, 1); on = false; }
    else { list.unshift(d); on = true; }
    write(list);
    setBtnState(btn, on);
    syncByIds(d.id, on);
  }

  function syncButtons() {
    var list = read();
    var ids = {};
    list.forEach(function (i) { ids[String(i.id)] = true; });
    var all = document.querySelectorAll('[data-fav-id]');
    for (var i = 0; i < all.length; i++) {
      setBtnState(all[i], !!ids[String(all[i].getAttribute('data-fav-id'))]);
    }
  }

  function updateBadge() {
    var n = count();
    var els = document.querySelectorAll('[data-fav-count]');
    for (var i = 0; i < els.length; i++) {
      els[i].textContent = n;
      els[i].style.display = n > 0 ? '' : 'none';
    }
  }

  function heartSvg() {
    return '<svg width="20" height="20" viewBox="0 0 24 24" fill="#F27A1A" stroke="#F27A1A" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>';
  }

  function favAttrs(i) {
    return 'data-fav-id="' + escapeHtml(i.id) + '" '
      + 'data-fav-handle="' + escapeHtml(i.handle) + '" '
      + 'data-fav-title="' + escapeHtml(i.title) + '" '
      + 'data-fav-vendor="' + escapeHtml(i.vendor) + '" '
      + 'data-fav-url="' + escapeHtml(i.url) + '" '
      + 'data-fav-image="' + escapeHtml(i.image) + '" '
      + 'data-fav-price="' + escapeHtml(i.price) + '" '
      + 'data-fav-compare="' + escapeHtml(i.compare) + '"';
  }

  /* Favori kayıtları localStorage'da tutulduğu için fiyat, indirim ve stok
     bilgisi ürün eklendiği andaki haliyle donuyordu. Önbellekten basılan kart
     ilk görüntü için kullanılır, ardından her kart sunucudan tazelenir:
     /products/<handle>?view=card gerçek ürün kartını döndürür. Ürün artık
     yayında değilse (404) favori listeden düşülür. */
  function refreshCards(container, list) {
    if (!window.fetch || !window.DOMParser || !list.length) return;

    list.forEach(function (item) {
      if (!item.handle) return;
      var slot = container.querySelector('[data-fav-slot="' + cssEscape(item.handle) + '"]');
      if (!slot) return;

      fetch('/products/' + encodeURIComponent(item.handle) + '?view=card', {
        headers: { 'Accept': 'text/html' }
      })
        .then(function (response) {
          if (response.status === 404) return null;
          if (!response.ok) throw new Error('favorites ' + response.status);
          return response.text();
        })
        .then(function (html) {
          /* Ürün yayından kaldırılmış: kartı ve kaydı sessizce düşür.
             write() yerine persist() kullanılır; write() tüm listeyi yeniden
             basıp bu tazeleme turunu baştan başlatırdı. */
          if (html == null) {
            slot.remove();
            persist(read().filter(function (i) { return String(i.id) !== String(item.id); }));
            updateBadge();
            var head = document.getElementById('favorites-count');
            if (head) head.textContent = count();
            if (!count()) renderPage();
            return;
          }

          var card = new DOMParser().parseFromString(html, 'text/html').querySelector('.product-card');
          if (!card) return;
          slot.innerHTML = '';
          slot.appendChild(card);
          syncButtons();
        })
        .catch(function () { /* önbellekten basılan kart ekranda kalır */ });
    });
  }

  function cssEscape(value) {
    return String(value).replace(/["\\]/g, '\\$&');
  }

  function renderPage() {
    var container = document.getElementById('favorites-grid');
    if (!container) return;
    var list = read();
    var empty = document.getElementById('favorites-empty');
    var head = document.getElementById('favorites-count');
    if (head) head.textContent = list.length;

    if (!list.length) {
      container.innerHTML = '';
      if (empty) empty.style.display = '';
      return;
    }
    if (empty) empty.style.display = 'none';

    container.innerHTML = list.map(function (i) {
      var img = i.image
        ? '<img src="' + escapeHtml(i.image) + '" alt="' + escapeHtml(i.title) + '" loading="lazy">'
        : '<div class="product-card__placeholder"></div>';
      var oldrow = i.compare
        ? '<div class="product-card__oldrow"><span class="product-card__price-compare">' + escapeHtml(i.compare) + '</span></div>'
        : '';
      return '<div data-fav-slot="' + escapeHtml(i.handle) + '">'
        + '<div class="product-card">'
        + '<div class="product-card__image">'
          + '<a href="' + escapeHtml(i.url) + '" class="product-card__media">' + img + '</a>'
          + '<button type="button" class="product-card__fav is-fav" ' + favAttrs(i)
            + ' aria-label="Favorilerden çıkar">' + heartSvg() + '</button>'
        + '</div>'
        + '<a href="' + escapeHtml(i.url) + '" class="product-card__info">'
          + (i.vendor ? '<div class="product-card__brand">' + escapeHtml(i.vendor) + '</div>' : '')
          + '<div class="product-card__title">' + escapeHtml(i.title) + '</div>'
          + oldrow
          + '<div class="product-card__price-current' + (i.compare ? ' is-discount' : '') + '">' + escapeHtml(i.price) + '</div>'
        + '</a>'
        + '</div>'
      + '</div>';
    }).join('');

    refreshCards(container, list);
  }

  function update() {
    updateBadge();
    renderPage();
  }

  window.vivendaFav = { toggle: toggle, has: has, count: count, sync: syncButtons };
  window.vivenda = window.vivenda || {};
  window.vivenda.fav = { toggle: toggle };

  /* Favori butonları şablonlarda satır içi onclick ile bağlanıyordu. Tıklama
     document üzerinde dinlenince hem şablonlardan satır içi JavaScript kalkar
     (içerik güvenlik politikası sıkılaştırılabilir) hem de AJAX ile sonradan
     eklenen kartların butonları ek bir işlem gerekmeden çalışır. */
  document.addEventListener('click', function (event) {
    if (!event.target || !event.target.closest) return;
    var btn = event.target.closest('[data-fav-id]');
    if (!btn) return;
    event.preventDefault();
    toggle(btn);
  });

  function init() { syncButtons(); updateBadge(); renderPage(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  window.addEventListener('pageshow', init);
})();
